import axios from 'axios';
import qs from 'qs';

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api base_url
  timeout: 15 * 60 * 1000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    if (config.qs) {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone interceptor
service.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error.response); // for debug
    return Promise.reject(error);
  }
);

export default service;
